import { Link } from "react-router-dom";
import { ShieldCheck, UserCheck, FlaskConical, Fingerprint, ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/Reveal";
import { TSM4_PRODUCTS } from "@/config/site";

const ICONS = { shield: ShieldCheck, "user-check": UserCheck, flask: FlaskConical, fingerprint: Fingerprint };
const ACCENTS = ["border-teal", "border-navy", "border-amber", "border-teal"];

const StatusChip = ({ status }) =>
  status === "coming_soon" ? (
    <span className="inline-flex items-center rounded-full border border-dashed border-tealdeep/60 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-tealdeep" data-testid="tsm4-card-coming-soon">
      Coming Soon
    </span>
  ) : (
    <span className="inline-flex items-center rounded-full border border-tealdeep/25 bg-tealdeep/5 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-tealdeep">
      Available Now
    </span>
  );

export const TSM4Suite = () => (
  <section id="tsm4" className="bg-white py-24 lg:py-32">
    <div className="container-tsm">
      <FadeIn className="max-w-3xl">
        <p className="eyebrow">The TSM4 Product Suite</p>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl" data-testid="tsm4-headline">
          TSM4 <span className="text-teal">|</span> Four Solutions. One Smarter Business.
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink/70">
          Technology, screening, and readiness services built to work together — so managing risk stops being a
          scramble and starts being a system.
        </p>
      </FadeIn>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="tsm4-cards">
        {TSM4_PRODUCTS.map((p, i) => {
          const Icon = ICONS[p.icon];
          return (
            <FadeIn key={p.name} delay={i * 0.08} className="h-full">
              <article
                className={`group flex h-full flex-col rounded-xl border border-navy/10 border-t-4 bg-paper p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_rgb(23,43,58,0.12)] ${ACCENTS[i]}`}
                data-testid={`tsm4-card-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${i === 0 ? "bg-teal" : i === 1 ? "bg-navy" : i === 2 ? "bg-amber text-navy" : "bg-navy"} text-white`}>
                    <Icon className="h-5 w-5" />
                  </span>
                  <StatusChip status={p.status} />
                </div>
                <h3 className="mt-5 text-xl font-extrabold tracking-tight text-navy" data-testid={`tsm4-card-name-${i + 1}`}>
                  {p.name}
                </h3>
                <p className="mt-1 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-tealdeep">{p.label}</p>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/65">{p.description}</p>
                <Link
                  to={p.href}
                  data-testid={`tsm4-card-cta-${i + 1}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-navy transition-colors hover:text-tealdeep"
                >
                  {p.status === "coming_soon" ? "Join the Interest List" : i === 0 ? "Explore MITIVISE" : `Explore ${p.name.replace("TSM ", "")}`}
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </article>
            </FadeIn>
          );
        })}
      </div>
    </div>
  </section>
);
